export const apis = {
    //Events
    GET_EVENTS: 'api/events',
    GET_EVENT_BY_ID: 'api/geteventbyid/',
    SET_TRANSACTION: 'api/setTransaction',
};